import { GlobalStatus } from "@gtpl/shared-models/common-models";


export class LoadingSheetSaleOrderReq {
    saleOrderId?: number;

    constructor(
        saleOrderId?:number,
        ){
      this.saleOrderId = saleOrderId;

    }
  }





  export class DailySheetData{
    dailySheetdate?:string;
    fromDate?:string;
    toDate?:string;



    constructor(
      dailySheetdate?:string,
      fromDate?:string,
      toDate?:string
    ){
      this.dailySheetdate=dailySheetdate
      this.fromDate=fromDate
      this.toDate=toDate
    }

  }